/* eslint-disable no-console */
import React from 'react';
import './style.scss';
import Slider from 'react-slick';
import ELiquidSlide from './slides/ELiquid';
import ACEDeliverySystem from './slides/ACEDeliverySystem';
import MainIntroSlide from './slides/MainIntroSlide';

const HeroSwiper = () => (
    <div className="hero-swiper">
        <Slider
            className="carousel"
            {...{
                arrows: false,
                lazyLoad: true,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: 0,
            }}
        >

            {/* {[0, 0, 0].map(() => ( */}
            {/* <div className="swiper-slide"> */}
            {/* <img */}
            {/* className="hero-swiper__background" */}
            {/* src="https://10minuteideas.com/wp-content/uploads/2018/08/vaping-lifestyle.jpg" */}
            {/* alt="Vaping Lifestyle" */}
            {/* /> */}
            {/* <div className="hero-content"> */}
            {/* <div className="title is-size-2-desktop
            is-size-5-mobile">New Ace Pod CBD Delivery System + 1 free pod</div> */}
            {/* <div className="subtitle is-size-2-desktop is-size-5-mobile">£29.99</div> */}
            {/* <Link className="button is-large" to="/home">Shop Now</Link> */}
            {/* </div> */}
            {/* </div> */}
            {/* ))} */}
            {/* <div className="swiper-slide"> */}
            {/*    <BlackFridaySlide /> */}
            {/* </div> */}

            <div className="swiper-slide">
                <MainIntroSlide />
            </div>

            <div className="swiper-slide">
                <ACEDeliverySystem />
            </div>

            <div className="swiper-slide">
                <ELiquidSlide />
            </div>
        </Slider>
    </div>
);

export default HeroSwiper;
